/**
 * @file Контроллер для обработки взаимодействий пользователя с Field1
 * @module membrane/src/visual/field1/field1Controller
 * 
 * Обрабатывает движение мыши и скролл для возмущения поля.
 */

/**
 * Состояние контроллера
 */
export interface Field1ControllerState {
  mouse: [number, number];
  zoom: number;
  isInteracting: boolean;
}

/**
 * Контроллер для Field1
 */
export class Field1Controller {
  private state: Field1ControllerState = {
    mouse: [0.5, 0.5],
    zoom: 1.0,
    isInteracting: false,
  };
  
  private targetMouse: [number, number] = [0.5, 0.5];
  private targetZoom: number = 1.0;
  private smoothing = 0.05; // Плавность переходов
  
  /**
   * Обновляет позицию мыши (нормализованные координаты 0-1)
   */
  setMouse(x: number, y: number) {
    this.targetMouse = [x, y];
    this.state.isInteracting = true;
  }
  
  /**
   * Обновляет уровень зума
   */
  setZoom(zoom: number) {
    this.targetZoom = Math.max(0.5, Math.min(3.0, zoom));
  }
  
  /**
   * Обновляет состояние с плавной интерполяцией
   */
  update() {
    // Плавная интерполяция мыши
    this.state.mouse[0] += (this.targetMouse[0] - this.state.mouse[0]) * this.smoothing;
    this.state.mouse[1] += (this.targetMouse[1] - this.state.mouse[1]) * this.smoothing;
    
    // Плавная интерполяция зума
    this.state.zoom += (this.targetZoom - this.state.zoom) * this.smoothing;
    
    // Сбрасываем флаг взаимодействия через некоторое время
    if (this.state.isInteracting) {
      setTimeout(() => {
        this.state.isInteracting = false;
      }, 2000);
    }
  }
  
  /**
   * Получает текущее состояние
   */
  getState(): Field1ControllerState {
    return { ...this.state };
  }
  
  /**
   * Сбрасывает состояние
   */
  reset() {
    this.state = {
      mouse: [0.5, 0.5],
      zoom: 1.0,
      isInteracting: false,
    };
    this.targetMouse = [0.5, 0.5];
    this.targetZoom = 1.0;
  }
}

